export default {
  api: {
    baseUrl: 'http://localhost:7300',
    chatUrl: 'http://localhost:7002',
    backOfficeUrl: 'http://localhost:7300/api',
    leadsUrl: 'http://localhost:7018',
  },
};
